module.exports = __webpack_public_path__ + "static/media/README.11d47abd.md";